import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.racket = languageMap.scheme = bracketIndenting({
	line: ";",
	block: ["#|", "|#"],
})
